import React, { ReactElement } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { COLORS, ScopeToggle, SearchField } from '../../shared';

export type OrgScope = 'all' | 'following';

export interface OrgsFilterBarProps {
  scope: OrgScope;
  onScopeChange: (scope: OrgScope) => void;

  allCount?: number;
  followingCount?: number;
  search: string;
  onSearchChange: (value: string) => void;
}

export const OrgsFilterBar = ({
  scope,
  onScopeChange,
  allCount,
  followingCount,
  search,
  onSearchChange,
}: OrgsFilterBarProps): ReactElement => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const scopeOptions: [
    { value: OrgScope; label: string; count?: number },
    { value: OrgScope; label: string; count?: number },
  ] = [
    { value: 'all', label: 'All organizations', count: allCount },
    { value: 'following', label: 'My organizations', count: followingCount },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'stretch', md: 'center' },
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: '12px', md: '16px' },
        width: '100%',
        flexWrap: 'wrap',
      }}
    >
      <ScopeToggle<OrgScope>
        ariaLabel="Organization scope"
        value={scope}
        options={scopeOptions}
        onChange={onScopeChange}
        fullWidth={!isDesktop}
      />
      <Box
        sx={{
          width: '1px',
          height: '24px',
          backgroundColor: COLORS.divider,
          flexShrink: 0,
          display: { xs: 'none', md: 'block' },
        }}
      />
      <Box sx={{ width: { xs: '100%', md: '320px' }, maxWidth: '100%' }}>
        <SearchField
          value={search}
          onChange={onSearchChange}
          placeholder="Search organizations"
          fullWidth
        />
      </Box>
    </Box>
  );
};
